import {
    IConfirmNewCorporateEmailResponse,
    IConfirmNewEmailRequest,
    IConfirmNewEmailResponse,
    IConfirmNewPhoneRequest,
    IConfirmNewPhoneResponse,
    IEditPasswordRequest,
    IGetCorporateEmailsResponse,
    IGetEmailResponse,
    IGetPasswordResponse,
    IGetPhoneResponse,
    ISendEmailRequest,
    ISendEmailResponse,
    ISendPhoneRequest,
    ISendPhoneResponse
} from "../../../../interface/Passport/Security/backend";
import {axiosInstanceToken} from "../../../../app/api";
import {IGetLKLinkResponse} from "../../../../interface/Auth/backend";

export async function getPhone(): Promise<IGetPhoneResponse> {

    return axiosInstanceToken.get<IGetPhoneResponse>('/user/phone').then(result => result.data)
}

export async function sendNewPhone(data: ISendPhoneRequest): Promise<ISendPhoneResponse> {

    return axiosInstanceToken.post<ISendPhoneResponse>('/user/phone/send-code', data).then(result => result.data)
}

export async function confirmNewPhone(data: IConfirmNewPhoneRequest): Promise<IConfirmNewPhoneResponse> {

    return axiosInstanceToken.post<IConfirmNewPhoneResponse>('/user/phone/submit-code', data).then(result => result.data)
}

export async function retryNewPhoneSMS(data: ISendPhoneRequest): Promise<ISendPhoneResponse> {

    return axiosInstanceToken.post<ISendPhoneResponse>('/user/phone/repeat-code', data).then(result => result.data)
}

export async function getEmail(): Promise<IGetEmailResponse> {

    return axiosInstanceToken.get<IGetEmailResponse>('/user/email').then(result => result.data)
}

export async function sendNewEmail(data: ISendEmailRequest): Promise<ISendEmailResponse> {

    return axiosInstanceToken.post<ISendEmailResponse>('/user/email/send-code', data).then(result => result.data)
}

export async function confirmNewEmail(data: IConfirmNewEmailRequest): Promise<IConfirmNewEmailResponse> {

    return axiosInstanceToken.post<IConfirmNewEmailResponse>('/user/email/submit-code', data).then(result => result.data)
}

export async function retryNewEmailCode(data: ISendEmailRequest): Promise<ISendEmailResponse> {

    return axiosInstanceToken.post<ISendEmailResponse>('/user/email/repeat-code', data).then(result => result.data)
}

export async function getPassword(): Promise<IGetPasswordResponse> {

    return axiosInstanceToken.get<IGetPasswordResponse>('/user/password').then(result => result.data)
}

export async function setNewPassword(data: IEditPasswordRequest): Promise<IGetPasswordResponse> {
    return axiosInstanceToken.put<IGetPasswordResponse>('/user/password', data).then(result => result.data)
}


export async function getCorporateEmails(): Promise<IGetCorporateEmailsResponse> {
    return axiosInstanceToken.get<IGetCorporateEmailsResponse>('user/corporate_email').then(result => result.data)
}

export async function sendNewCorporateEmail(data: ISendEmailRequest): Promise<ISendEmailResponse> {

    return axiosInstanceToken.post<ISendEmailResponse>('/user/email/send-code', data).then(result => result.data)
}

export async function confirmNewCorporateEmail(data: IConfirmNewEmailRequest): Promise<IConfirmNewCorporateEmailResponse> {

    return axiosInstanceToken.post<IConfirmNewCorporateEmailResponse>('/user/email/submit-code', data).then(result => result.data)
}

export async function retryNewCorporateEmailCode(data: ISendEmailRequest): Promise<ISendEmailResponse> {

    return axiosInstanceToken.post<ISendEmailResponse>('/user/email/repeat-code', data).then(result => result.data)
}

export async function getLKLink() {
    return axiosInstanceToken.get<IGetLKLinkResponse>(`lk-link`).then(res => res.data)
}